<style lang="scss">
  $infoPadding: 2vw;
  .swiper-container.featuredList {
    margin: 100px 0 0 0;
    overflow: visible;
    .swiper-wrapper {
      width: 36.5%;
      .swiper-slide {
        width: 100% !important;
        margin: 0 14.5% 0 0 !important;
      }
      a {
        display: block;
        position: relative;
        color: #232323;
        .bCover {
          width: 45%;
          padding: 0 0 64% 0;
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
        }
        .bInfo {
          position: absolute;
          top: 2vw;
          right: 0;
          bottom: 2vw;
          left: 45%;
          padding: $infoPadding;
          background-color: #fff;
          -webkit-box-shadow: 0 0 30px 0 rgba(0,0,0,.1);
          box-shadow: 0 0 30px 0 rgba(0,0,0,.1);
          white-space: normal;
          h3 {
            font-size: 16px;
            font-weight: 600;
          }
          p {
            margin: 15px 0;
            font-size: 14px;
            &.desc {
              height: 42px;
              overflow: hidden;
              font-style: italic;
            }
            &.price {
              position: absolute;
              bottom: 5.2vw;
              left: $infoPadding;
              font-size: 16px;
              font-weight: 600;
              color: #B9DD64;
              small {
                color: #232323;
                text-decoration: line-through;
              }
            }
          }
          .btn {
            position: absolute;
            display: block;
            width: calc(100% - 4vw);
            right: $infoPadding;
            bottom: $infoPadding;
            left: $infoPadding;
            text-transform: uppercase;
          }
        }
        .bookProgress {
          position: absolute;
          top: -60px;
          right: 45%;
          width: 120px;
          margin: 0 0 0 -60px;
          > div {
            padding-top: 30;
          }
        }
      }
    }
  }
  @media (max-width: 1300px) {
    .featuredList {
      p.desc {
        display: none;
      }
    }
  }
  .swiper-container.mobileBook {
    .swiper-wrapper {
      width: 100%;
      .swiper-slide {
        width: 100% !important;
        margin: 0 !important;
        a {
          position: relative;
          z-index: 10;
          display: block;
          width: 100%;
          margin: 0 auto;
          padding: 0 15px;
          color: #232323;
          &:hover {
            text-decoration: none;
          }
          .bCover {
            position: relative;
            z-index: 2;
            padding: 0 0 142% 0;
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
          }
          .bInfo {
            width: 90%;
            margin: 0 auto;
            padding: 40px;
            background-color: #fff;
            -webkit-box-shadow: 0 0 30px 0 rgba(0,0,0,.1);
            box-shadow: 0 0 30px 0 rgba(0,0,0,.1);
            white-space: normal;
            h3 {
              font-size: 16px;
              font-weight: 600;
            }
            p {
              margin: 15px 0;
              font-size: 14px;
              &.desc {
                height: 42px;
                overflow: hidden;
                font-style: italic;
              }
              &.price {
                font-size: 16px;
                font-weight: 600;
                color: #B9DD64;
                small {
                  color: #232323;
                  text-decoration: line-through;
                }
              }
            }
            .btn {
              display: block;
              width: 100%;
              text-transform: uppercase;
            }
          }
          .bookProgress {
            position: absolute;
            z-index: 3;
            top: 1%;
            right: calc(1% + 15px);
            width: 120px;
            > div {
              padding-top: 34px;
            }
          }
        }
      }
    }
  }
  @media (min-width: 992px) {
    .mobileBook {
      display: none;
    }
  }
</style>
<template>
  <div>
    <swiper :options="swiperOption" class="featuredList d-none d-lg-block">
      <swiper-slide v-for="(bookItem, index) in books" :key="index">
        <a :href="bookItem.url">
          <div class="bCover" v-bind:style="{backgroundImage: backgroundImage(bookItem.imgUrl_url)}"></div>
          <div class="bInfo">
            <h3>{{bookItem.title}}</h3>
            <p>by {{bookItem.author}}</p>
            <p class="desc">{{bookItem.title_line}}</p>
            <p class="price">
              <small>{{bookItem.externalPrice}} Ft</small>
              {{bookItem.price}} Ft
            </p>
            <button class="btn btn-primary">Megtekintés</button>
          </div>
          <div class="bookProgress">
            <div>{{bookItem.available_quantity}}/1000</div>
            <ProgressCircle :perc="((1000-bookItem.available_quantity)/1000*100).toString()"></ProgressCircle>
          </div>
        </a>
      </swiper-slide>
    </swiper>
    <swiper :options="swiperOptionMobile" class="mobileBook d-lg-none">
      <swiper-slide v-for="(bookItem, index) in books" :key="index">
        <a :href="bookItem.url">
          <div class="bCover" v-bind:style="{backgroundImage: backgroundImage(bookItem.imgUrl_url)}"></div>
          <div class="bInfo">
            <h3>{{bookItem.title}}</h3>
            <p>by {{bookItem.author}}</p>
            <p class="desc">{{bookItem.title_line}}</p>
            <p class="price">
              <small>{{bookItem.externalPrice}} Ft</small>
              {{bookItem.price}} Ft
            </p>
            <button class="btn btn-primary">Megtekintés</button>
          </div>
          <div class="bookProgress">
            <div>{{bookItem.available_quantity}}/{{bookItem.maxQuantity}}</div>
            <ProgressCircle :perc="((bookItem.maxQuantity-bookItem.available_quantity)/bookItem.maxQuantity*100).toString()"></ProgressCircle>
          </div>
        </a>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import ProgressCircle from '../partials/progress-circle'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'FrontendHomeFeatured',
  components: {
    ProgressCircle,
    swiper,
    swiperSlide
  },
  props: {
    books: { type: Array }
  },
  data: function () {
    return {
      swiperOption: {
        slidesPerView: 2,
        spaceBetween: 0
      },
      swiperOptionMobile: {
        slidesPerView: 1,
        spaceBetween: 0
      }
    }
  },
  methods: {
    backgroundImage (_imgUrl) {
      return 'url(' + _imgUrl + ')'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/frontend/home/featured.vue